import React from 'react';

interface BookmarkIconProps {
    selected?: boolean;
    className?: string;
}

const BookmarkIcon: React.FC<BookmarkIconProps> = ({ selected = false, className = '' }) => (
    <svg
        className={`${className}`}
        fill="none"
        viewBox="0 0 14 14"
        aria-hidden="true"
        focusable="false"
    >
        <path
            d="M11.4098 12.6681L6.99984 9.51812L2.58984 12.6681V2.58812C2.58984 2.25395 2.72259 1.93347 2.95889 1.69717C3.19519 1.46087 3.51567 1.32813 3.84984 1.32812H10.1498C10.484 1.32813 10.8045 1.46087 11.0408 1.69717C11.2771 1.93347 11.4098 2.25395 11.4098 2.58812V12.6681Z"
            fill={selected ? "#095EB2" : "#fff"}
            stroke={selected ? "#095EB2" : "#757575"}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default BookmarkIcon; 